import { type MouseEvent } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { type IPageUser } from '../../../../common/interfaces';
import { AVATAR_PLACEHOLDER } from '../../common/const';
import { Avatar } from '../Tabbed/common/styles';
import { decodeHtml } from '../../../../helpers';
import { isUserAccessRestricted } from '../../../../helpers/userAccess';

const AvatarActionButton = styled.button`
  padding: 0;
  margin: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  display: block;
`;

interface UserAvatarProps {
  readonly user: IPageUser;
  readonly onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  readonly size?: number;
}

export const UserAvatar = ({ user, onClick, size }: UserAvatarProps) => {
  const intl = useIntl();
  const avatarSrc = user?.avatarUrl || AVATAR_PLACEHOLDER;
  const isAccessRestricted = isUserAccessRestricted(user?.userType);
  const avatarAlt = intl.formatMessage({ id: 'page.UsersAvatar', defaultMessage: "User's avatar" });
  const avatarTitle = decodeHtml(user?.name);

  const avatar = <Avatar src={avatarSrc} alt={avatarAlt} title={avatarTitle} $size={size} />;

  if (isAccessRestricted || !user?.linkUrl) {
    return avatar;
  }

  if (onClick) {
    return (
      <AvatarActionButton type="button" onClick={onClick}>
        {avatar}
      </AvatarActionButton>
    );
  }

  return (
    <a href={user.linkUrl} title={avatarTitle}>
      {avatar}
    </a>
  );
};
